var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chart-page-wrapper"
  }, [(!_vm.leftMenuClosed || !_vm.rightMenuClosed) && _vm.$vuetify.breakpoint.smAndDown ? _c('div', {
    staticClass: "dashboard-overlay",
    on: {
      "click": _vm.closeMenusOnMobile
    }
  }) : _vm._e(), _c('div', {
    staticClass: "chart-page",
    class: {
      'left-menu-closed': _vm.leftMenuClosed,
      'right-menu-closed': _vm.rightMenuClosed
    },
    attrs: {
      "id": "body"
    }
  }, [_c('div', {
    staticClass: "content-chart"
  }, [_c('div', {
    ref: "chartBox",
    staticClass: "chart-resizable",
    class: {
      'chart-resizable--no-data': _vm.showEmptyStateMessage
    },
    style: _vm.chartContainerStyle,
    on: {
      "pointerdown": _vm.onChartBoxPointerDown
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "spinner-layer",
    attrs: {
      "id": "spinner-layer"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _c('h3', [_vm._v("Loading Chart")])]), _c('LineChartGenerator', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showEmptyStateMessage,
      expression: "!showEmptyStateMessage"
    }],
    ref: "chartRef",
    staticClass: "chart-canvas",
    attrs: {
      "id": "chart",
      "chart-options": _vm.chartOptions,
      "chart-data": _vm.chartData
    }
  }), _vm.showEmptyStateMessage ? _c('div', {
    staticClass: "empty-state-message"
  }, [_vm._v(" No data selected. Choose a subject, session, and trial to display the chart. ")]) : _vm._e()], 1), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showEmptyStateMessage,
      expression: "!showEmptyStateMessage"
    }],
    staticClass: "chart-reset-zoom-btn",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.onResetZoom
    }
  }, [_vm._v(" Reset Zoom ")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.leftMenuClosed,
      expression: "leftMenuClosed"
    }],
    staticClass: "fixed-button fixed-button-to-left"
  }, [_c('v-btn', {
    on: {
      "click": _vm.toggleLeftMenu
    }
  }, [_vm._v(" Data ")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.rightMenuClosed && !_vm.showEmptyStateMessage,
      expression: "rightMenuClosed && !showEmptyStateMessage"
    }],
    staticClass: "fixed-button fixed-button-to-right"
  }, [_c('v-btn', {
    on: {
      "click": _vm.toggleRightMenu
    }
  }, [_vm._v(" Settings ")])], 1), _c('v-card', {
    staticClass: "sidebar left-sidebar"
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('span', [_vm._v("Data")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.toggleLeftMenu
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_vm._l(_vm.selected_trials, function (trial, idx) {
    return _c('div', {
      key: trial.uuid
    }, [_c('TrialSelect', {
      attrs: {
        "trialSelection": trial,
        "selectionIndex": idx,
        "publicSessionId": _vm.public_session_id
      },
      on: {
        "trial-selected": _vm.captureTrialSelection,
        "trial-remove": _vm.removeTrialSelection
      }
    })], 1);
  }), _c('v-select', {
    attrs: {
      "items": _vm.x_quantities,
      "label": "X Quantity",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.onXQuantitySelected
    },
    model: {
      value: _vm.x_quantity_selected,
      callback: function ($$v) {
        _vm.x_quantity_selected = $$v;
      },
      expression: "x_quantity_selected"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.y_quantities,
      "label": "Y Quantities",
      "multiple": "",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.onYQuantitySelected
    },
    model: {
      value: _vm.y_quantities_selected,
      callback: function ($$v) {
        _vm.y_quantities_selected = $$v;
      },
      expression: "y_quantities_selected"
    }
  }), _c('v-dialog', {
    attrs: {
      "max-width": "400",
      "content-class": "app-dialog"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          ref: "downloadDialogActivator",
          staticClass: "mt-4",
          attrs: {
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-download")]), _vm._v(" Download Chart ")], 1)];
      }
    }]),
    model: {
      value: _vm.downloadDialog,
      callback: function ($$v) {
        _vm.downloadDialog = $$v;
      },
      expression: "downloadDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h6"
  }, [_vm._v(" Choose background ")]), _c('v-card-text', [_c('v-radio-group', {
    model: {
      value: _vm.downloadBackground,
      callback: function ($$v) {
        _vm.downloadBackground = $$v;
      },
      expression: "downloadBackground"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Black background",
      "value": "black"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "White background",
      "value": "white"
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.downloadDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.onConfirmDownload
    }
  }, [_vm._v(" Download ")])], 1)], 1)], 1), _vm.loggedIn ? _c('div', {
    staticClass: "left d-flex flex-column pa-2"
  }, [_c('v-btn', {
    staticClass: "w-100 mt-4 sidebar-action-btn",
    attrs: {
      "to": {
        name: 'SelectSession'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to session list ")], 1), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showEmptyStateMessage,
      expression: "!showEmptyStateMessage"
    }],
    staticClass: "w-100 mt-4 sidebar-action-btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'Session',
          params: {
            id: _vm.current_session_id
          }
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-play-circle-outline")]), _vm._v(" Go to Visualizer ")], 1)], 1) : _vm._e()], 2)], 1), _c('v-card', {
    staticClass: "sidebar right-sidebar"
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('span', [_vm._v("Options")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.toggleRightMenu
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Title",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.plugins.title.text,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.plugins.title, "text", $$v);
      },
      expression: "chartOptions.plugins.title.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Subtitle",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.plugins.subtitle.text,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.plugins.subtitle, "text", $$v);
      },
      expression: "chartOptions.plugins.subtitle.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "X Axis Title",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.scales.x.title.text,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.scales.x.title, "text", $$v);
      },
      expression: "chartOptions.scales.x.title.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Y Axis Title",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.scales.y.title.text,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.scales.y.title, "text", $$v);
      },
      expression: "chartOptions.scales.y.title.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Chart Width (px)",
      "dense": "",
      "outlined": "",
      "type": "number"
    },
    on: {
      "change": _vm.onChartSizeInput,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onChartSizeInput.apply(null, arguments);
      }
    },
    model: {
      value: _vm.chart_width_input,
      callback: function ($$v) {
        _vm.chart_width_input = $$v;
      },
      expression: "chart_width_input"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Chart Height (px)",
      "dense": "",
      "outlined": "",
      "type": "number"
    },
    on: {
      "change": _vm.onChartSizeInput,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onChartSizeInput.apply(null, arguments);
      }
    },
    model: {
      value: _vm.chart_height_input,
      callback: function ($$v) {
        _vm.chart_height_input = $$v;
      },
      expression: "chart_height_input"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.chart_color_scales_options,
      "label": "Color Scale",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.drawChart
    },
    model: {
      value: _vm.chart_color_scales_selected,
      callback: function ($$v) {
        _vm.chart_color_scales_selected = $$v;
      },
      expression: "chart_color_scales_selected"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Line Width",
      "dense": "",
      "outlined": "",
      "type": "number"
    },
    on: {
      "input": _vm.drawChart
    },
    model: {
      value: _vm.chart_line_width,
      callback: function ($$v) {
        _vm.chart_line_width = _vm._n($$v);
      },
      expression: "chart_line_width"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.chart_point_style_options,
      "label": "Point Style",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.drawChart
    },
    model: {
      value: _vm.chart_point_style,
      callback: function ($$v) {
        _vm.chart_point_style = $$v;
      },
      expression: "chart_point_style"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Point Size",
      "dense": "",
      "outlined": "",
      "type": "number"
    },
    on: {
      "input": _vm.drawChart
    },
    model: {
      value: _vm.chart_point_radius,
      callback: function ($$v) {
        _vm.chart_point_radius = _vm._n($$v);
      },
      expression: "chart_point_radius"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.chart_legend_position,
      "label": "Legend Position",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.plugins.legend.position,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.plugins.legend, "position", $$v);
      },
      expression: "chartOptions.plugins.legend.position"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.chart_legend_alignment,
      "label": "Legend Alignment",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.chartOptions.plugins.legend.align,
      callback: function ($$v) {
        _vm.$set(_vm.chartOptions.plugins.legend, "align", $$v);
      },
      expression: "chartOptions.plugins.legend.align"
    }
  })], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }